"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _reactDom = _interopRequireDefault(require("react-dom"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("..");

var propTypes = {
  children: _propTypes["default"].node,
  active: _propTypes["default"].bool,
  container: _.DOMElementType
};
var defaultProps = {
  children: null,
  active: true,
  container: null
};

function Portal(props) {
  var active = props.active,
      children = props.children,
      container = props.container;
  return active ? /*#__PURE__*/_reactDom["default"].createPortal(children, container || document.body) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
}

Portal.propTypes = propTypes;
Portal.defaultProps = defaultProps;
var _default = Portal;
exports["default"] = _default;
//# sourceMappingURL=Portal.js.map